import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import * as actions from './my-partner-account.actions';
import { initialState, MyPartnerAccountState } from './my-partner-account.state';

const reducer: ActionReducer<MyPartnerAccountState, Action> = createReducer(
  initialState,

  on(
    actions.isPayoutAvailable,
    (state): MyPartnerAccountState => ({
      ...state,
      loading: true,
      payoutAvailable: false,
    })
  ),
  on(
    actions.isPayoutAvailableSuccess,
    (state, { payoutAvailable }): MyPartnerAccountState => ({
      ...state,
      loading: false,
      payoutAvailable,
    })
  ),
  on(
    actions.isPayoutAvailableError,
    (state): MyPartnerAccountState => ({
      ...state,
      loading: false,
      payoutAvailable: false,
    })
  ),

  on(
    actions.requestPayout,
    (state): MyPartnerAccountState => ({
      ...state,
      loading: true,
      payoutAvailable: false,
    })
  ),
  on(
    actions.requestPayoutSuccess,
    (state): MyPartnerAccountState => ({
      ...state,
      loading: false,
      payoutAvailable: false,
    })
  ),
  on(
    actions.requestPayoutError,
    (state): MyPartnerAccountState => ({
      ...state,
      loading: false,
      payoutAvailable: false,
    })
  ),
  on(
    actions.getMyPartnerAccountDetails,
    actions.getMyPointsSum,
    (state): MyPartnerAccountState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    actions.getMyPartnerAccountDetailsSuccess,
    (state, { discountCode }): MyPartnerAccountState => ({
      ...state,
      partnerCodeDetails: discountCode,
      loading: false,
    })
  ),
  on(
    actions.getMyPointsSumSuccess,
    (state, { sumOfPoints }): MyPartnerAccountState => ({
      ...state,
      sumOfPartnerPoints: sumOfPoints,
      loading: false,
    })
  ),
  on(
    actions.getMyPayoutsHistory,
    (state): MyPartnerAccountState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    actions.getMyPayoutsHistorySuccess,
    (state, { payoutsHistory }): MyPartnerAccountState => ({
      ...state,
      loading: false,
      payoutsHistory,
    })
  ),
  on(
    actions.getMyPartnerAccountDetailsError,
    actions.getMyPointsError,
    actions.getMyPayoutsHistoryError,
    (state): MyPartnerAccountState => ({
      ...state,
      loading: false,
    })
  )
);

export function myPartnerAccountReducer(
  state: MyPartnerAccountState | undefined,
  action: Action
): MyPartnerAccountState {
  return reducer(state, action);
}
